import styled from "styled-components";

import bgImg from "../../assets/img/foot.jpg";

export const FooterWrapper = styled.div`
    background: url(${bgImg}) 50% 50% / cover no-repeat;
    text-align: center;
    padding: 30px;
    p {
        color: white;
        font-size: 14px;
        line-height: 30px;
    }
    @media screen and (max-width: 750px) {
        padding: 15px 5px;
        p {
            font-size: 12px;
        }
    }
`;
